import React, { useState, useCallback, memo } from "react";
import { Form } from "react-bootstrap";
import styles from "../../Tax.module.scss";

const TaxRateField = memo(
  ({ label, value, onSave, isLoading = false, disabled = false }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [localValue, setLocalValue] = useState(value);

    // Update local value and exit edit mode when prop changes
    React.useEffect(() => {
      setLocalValue(value);
      setIsEditing(false);
    }, [value]);

    const isNumber = useCallback((val) => {
      return RegExp(/^-?\d+\.?\d*$/).test(val);
    }, []);

    const handleChange = useCallback(
      (e) => {
        const inputValue = e.target.value;

        if (isNumber(inputValue)) {
          let cleanValue = inputValue;
          // Remove leading zeros except for "0." pattern
          if (
            cleanValue.startsWith("0") &&
            cleanValue.length > 1 &&
            !cleanValue.startsWith("0.")
          ) {
            cleanValue = cleanValue.replace(/^0+/, "");
          }
          setLocalValue(cleanValue);
        } else if (inputValue === "") {
          setLocalValue("");
        }
      },
      [isNumber],
    );

    const handleSave = useCallback(() => {
      onSave(Number(localValue));
      setIsEditing(false);
    }, [localValue, onSave]);

    const handleCancel = useCallback(() => {
      setLocalValue(value);
      setIsEditing(false);
    }, [value]);

    return (
      <div className={styles.formGroup}>
        <label className={styles.label}>{label}</label>
        <div className={styles.buttonGroup}>
          <Form.Control
            type="text"
            value={localValue}
            onChange={handleChange}
            disabled={!isEditing || disabled}
            className={styles.input}
          />
          {!isEditing ? (
            <button
              className={styles.buttonPrimary}
              onClick={() => setIsEditing(true)}
              disabled={disabled || isLoading}
            >
              Edit
            </button>
          ) : (
            <>
              <button
                className={styles.buttonSuccess}
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className={styles.buttonWarning}
                onClick={handleCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    );
  },
);

TaxRateField.displayName = "TaxRateField";

export default TaxRateField;
